module.exports = __webpack_public_path__ + "static/media/accessory1.ebddd1cf.webp";